import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { isNil } from '@gfe/core/utils/shared-utils';
import {
  StatusPillComponent,
  StatusPillVariant
} from '@gfe/shared/components/status-pill/status-pill.component';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '../../table-cell.component';

export interface PlanningStatus {
  code: 'ok';
}

const CODE_VARIANTS: Record<PlanningStatus['code'], StatusPillVariant> = {
  ok: 'success'
};

@Component({
  selector: 'app-plan-status-cell',
  imports: [TranslatePipe, StatusPillComponent],
  templateUrl: './plan-status-cell.component.html',
  styles: ``
})
export class PlanStatusCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = [];
  availableCellShiftActions: CellOverlayAction[] = [];

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<PlanningStatus | undefined>(() => {
    const value = this.value();
    if (isNil(value)) {
      return undefined;
    }
    return value as PlanningStatus;
  });

  protected variant = computed<StatusPillVariant>(
    () => CODE_VARIANTS[this.processedValue()?.code as PlanningStatus['code']] ?? 'neutral'
  );
}
